// Used a separate file for bundling
import { isFontFamiliesPanelSupported } from "../font-families-panel/menu-info";
import { isTextAlignmentPanelSupported } from "../text-alignment-menu/menu-info";
import { isTextColorPanelSupported } from "../text-color-panel/menu-info";
import { isTextSizePanelSupported } from "../text-size-panel/menu-info";
import { isTextStylePanelSupported } from "../text-style-panel/menu-info";
import { isTextValuePanelSupported } from "../text-value-panel/menu-info";

function isDeleteTextZoneSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	return dashboard.canDeleteTextZone(zone);
}

function isClearTextZoneSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	return dashboard.canSetTextValue(zone);
}

export function isAddTextZoneSupported(
	page: eXpress.core.IPageZone,
	dashboard: eXpress.TextZoneDashboard,
) {
	return dashboard.canAddTextZoneToPage(page);
}

export function isBottomTextMenuSupported(
	zone: eXpress.core.IZone | undefined,
	page: eXpress.core.IPageZone | undefined | null,
	dashboard: eXpress.TextZoneDashboard,
) {
	return (
		isTextValuePanelSupported(zone, page?.definition, dashboard) ||
		isTextAlignmentPanelSupported(zone, page?.definition, dashboard) ||
		isTextSizePanelSupported(zone, dashboard) ||
		isFontFamiliesPanelSupported(zone, dashboard) ||
		isTextColorPanelSupported(zone, dashboard) ||
		isTextStylePanelSupported(zone, page?.definition, dashboard) ||
		isDeleteTextZoneSupported(zone, dashboard) ||
		isClearTextZoneSupported(zone, dashboard) ||
		(!!page && isAddTextZoneSupported(page, dashboard))
	);
}
